import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import OfficeRent from "../components/officerent.jsx";
import Footer from "../components/footer.jsx";

function OfficeRentpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <OfficeRent/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default OfficeRentpage;
